export default __webpack_public_path__ + "static/media/ongoingProject.0dbc23d6.webp";